export default __webpack_public_path__ + "070656aa1477d765a425bfc117ba5ba8.svg";